import React from "react";
import styled from "styled-components";
import { content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Modal from "@ui-kit/modal";
import { tr } from "@radarly/i18n";
import { PasteID } from "@radarly/models/insight-pages/editor";

export interface IProps {
  onClose: () => void;
  onApply: () => void;
  locale: Locale;
  type: PasteID;
}

const Text = styled.p`
  color: ${(props) => content(props, "secondary")};
`;

const ConfirmationPasteModal = ({ onClose, onApply, locale, type }: IProps) => {
  return (
    <Modal
      title={tr(locale, `INSIGHT_PAGES_EDITOR::REPLACE_${type}`)}
      onCancel={onClose}
      cancelLabel={tr(locale, "FORM::CANCEL")}
      validateLabel={tr(locale, `INSIGHT_PAGES_EDITOR::REPLACE_${type}`)}
      onValidate={onApply}
      locale={locale}
      width="auto"
    >
      <Text>{tr(locale, `INSIGHT_PAGES_EDITOR::REPLACE_TEXT_${type}`)}</Text>
    </Modal>
  );
};

export default ConfirmationPasteModal;
